module.exports = __webpack_public_path__ + "img/wave.e1e2f8dc.svg";